import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import Tools from '@/components/tools/Tools.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import {mask} from 'vue-the-mask'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import ReinforcementRepository from '@/shared/http/repositories/access/reinforcement'
import localStoreHelper from '@/shared/utils/localStoreHelper'

const name = 'CollaboratorTableTravelExpense'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ
  },

  props: {
    // Quando true (tela de CONSULTA de Despesa Viagem) o componente e read-only:
    // zera editar, bloquear, reforco e o botao de adicionar colaborador.
    isConsulta: {
      type: Boolean,
      default: false
    }
  },

  updated () { },

  data () {
    return {
      AtualizaPrestacao: false,
      ArrayFuncionarioImpossibilitado: [],
      formataDataInicial: '',
      formataDatafim: '',
      espacos: [],
      funcionarioAdiantamentoId: null,
      number: '',
      collaboratorsArray: [],
      part: [],
      collabTravelExpenseIds: [],
      dataSearch: localStoreHelper.viagem.colaborador() || {},
      ObjLoteNovoFuncionario: {},
      selected: '',
      contato: '',
      dataCollaborator: [],
      EnumInfo: [],
      allGroup: [],
      editinfo: {
        valorLimiteDespesa: null,
        Adiantamento: null,
        funcionario: {
          cargo: {
            nome: null
          }
        }
      },
      editinfo2: {
        Adiantamento: null,
        // o irmao de Diversos manda o dele em tablecollaborator.js. Sem este campo o PUT de
        // AlteraValorAdiantamento chega sem TipoDespesa e o backend nao sabe rotular o log.
        TipoDespesa: 'DespesasViagem',
        // ZC-33: colaborador cadastrado com "Possui Saldo Existente?" antes de 2026-09-13 nao tem o
        // valor do saldo gravado (SaldoValor e [NotMapped]), entao o backend recusa a edicao ate
        // receber o numero OU a confirmacao de que nao ha saldo. `Saldo = false` sozinho nao serve
        // como confirmacao: e o mesmo valor de "nao mexeu no checkbox".
        Saldo: false,
        SaldoValor: 0,
        ConfirmaSemSaldoExistente: false
      },
      // funcionarioId que o backend recusou por base incompleta. Guarda o ID, nao um booleano: com
      // booleano, fechar e reabrir o modal apagava a marca e o operador tinha que tomar o erro de
      // novo pra ver onde digitar o saldo.
      saldoPendenteFuncionarioId: null,
      formAddDe: {
        TelefoneCelular: '',
        objnomeFuncionarios: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        TipoDespesa: 'DespesasViagem',
        Adiantamento: null,
        empresaId: null,
        cargoId: null,
        exclusao: false,
        contaId: null,
        Senha: '',
        Username: '',
        ConfSenha: '',
        Email: ''
      },
      nomeCargo: '',
      disableDados: false,
      valorAdiantamentoEnum: [],
      valorLimiteDespesa: [],
      senhaNaoConfere: undefined,
      TipoPerfil: 1,
      lock: {
        motivoBloqueio: '',
        Bloqueado: false
      },
      PopupmotivoBloqueio: '',
      iconLock: null,
      objColaborador: {},
      verificaBloqueio: false,
      reforcoEdit: null,
      dataReforco: [],
      ObjRefoco: [],
      details: [],
      deletingColaborators: {},
      acesso: {
        id: null,
        empresa: null,
        localidade: null
      }
    }
  },
  mounted () {
    this.GetEnumValorAdiantamento()
    this.GetEnumValue()
    this.Onload()
    this.GetAcesso()
  },

  computed: {
    filteredValorAdiantamentoEnum () {
      if (this.$store.getters['company/company'].localidade !== 'escl') {
        return this.valorAdiantamentoEnum.filter(data => data.text.includes('R$'))
      } else {
        return this.valorAdiantamentoEnum.filter(data => data.text.includes('CLP'))
      }
    },
    moneyOpts () {
      return Tools.moneyFormatHtml()
    },
    // O par de campos de saldo vale pro colaborador que o backend recusou, e so pra ele: a grid
    // inteira usa uma instancia so deste componente, entao sem comparar o id o campo apareceria no
    // proximo colaborador aberto. Guardar o id em vez de um booleano tambem faz o campo SOBREVIVER a
    // fechar e reabrir o modal — com booleano, o operador tinha que tomar o erro de novo pra ver
    // onde digitar.
    saldoPendente () {
      return this.saldoPendenteFuncionarioId !== null &&
             this.saldoPendenteFuncionarioId === this.editinfo.funcionarioId
    }
  },

  methods: {
    redirectToCollaboratorDetails (collabId) {
      // consulta=1 propaga o read-only pra tela de detalhe, que e rota separada (prop nao chega la)
      this.$router.push(`/despesa/viagem/colaborador/detalhes/funcionario?funcionario=${collabId}${this.isConsulta ? '&consulta=1' : ''}`)
    },
    openModalDelete (value) {
      this.exclusao = true
      let FuncionarioId = value.funcionarioId
      if (value.funcionarioAdiantamento === null) {
        this.funcionarioAdiantamentoId = null
      } else {
        this.funcionarioAdiantamentoId = value.funcionarioAdiantamentoId
      }
      loading.push()
      if (FuncionarioId != null && FuncionarioId !== undefined) {
        EmployeeRepository.Exclusao(this.funcionarioAdiantamentoId, FuncionarioId, this.CompanySelected)
          .then(Response => {
            if (Response.data) {
              loading.close()
              this.Onload()
              toast.success('Despesa Viagem exluida com sucesso')
            }
          })
          .catch((Error) => {
            this.$refs['add-despesa'].hide()
            loading.close()
            this.GetFuncionariosImpossibilitados({FuncionarioId: FuncionarioId, EmpresaId: this.CompanySelected, DespesaViagem: true})
            toast.warning(Error.response.data == null || Error.response.data === undefined ? 'Erro ao excluir' : Error.response.data)
          })
      } else {
        loading.close()
        toast.error('Erro ao excluir')
      }
    },

    verificaConfSenha (funcionarioId) {
      if (this.formAddDe.Senha === this.formAddDe.ConfSenha) {
        this.senhaNaoConfere = false
        this.verificaEspacos(funcionarioId)
      } else {
        this.senhaNaoConfere = true
        toast.error('Os campos senha e confirma senha não Coincidem')
      }
    },

    EditaAdiantamento (funcionarioId) {
      if (this.editinfo2.Adiantamento != null) {
        let companyid = this.CompanySelected
        this.editinfo2.Adiantamento = parseInt(this.editinfo2.Adiantamento)
        loading.push()
        var formData = new FormData()
        formData.append('funcionariDtoJson', JSON.stringify(this.editinfo2))
        EmployeeRepository.AlteraValorAdiantamento(funcionarioId, companyid, formData)
          .then(Response => {
            this.$refs['edit-despesa'].hide()
            this.limpaSaldoExistente()
            // resolvido: a marca sai, senao o par continuaria aparecendo pra quem ja declarou
            this.saldoPendenteFuncionarioId = null
            this.Onload()
            toast.success('Edição feita com sucesso')
            loading.close()
            if (Response.data) {
            } else {
              this.Onload()
              loading.close()
            }
          })
          .catch((Error) => {
            toast.error(Error.response.data)
            // ZC-33: o backend so recusa por base incompleta quem tem primeiro adiantamento lancado
            // com valor zero. Quem decide se este colaborador precisa declarar saldo e ele, nao a
            // tela: por isso o par de campos aparece a partir daqui, e nao para todo mundo.
            if (typeof Error.response.data === 'string' &&
                Error.response.data.indexOf('saldo existente') !== -1) {
              this.saldoPendenteFuncionarioId = funcionarioId
            }
            loading.close()
          })
      } else {
        toast.warning('Escolha o valor do novo adiantamento')
      }
    },

    limpaCampos () {
      this.zerarAutocomplete()
      this.formAddDe.nomeCargo = ''
      this.formAddDe.cargoId = null
      this.disableDados = false
      this.formAddDe.Adiantamento = null
      this.verificarFluxo = 0
      this.formAddDe.nomeCargo = ''
      this.formAddDe.TelefoneCelular = null
      this.formAddDe.Senha = null
      this.formAddDe.ConfSenha = null
      this.formAddDe.Username = null
      this.formAddDe.Email = null
      if (this.$refs.favorecidoTypaehead !== undefined) {
        this.$refs.favorecidoTypaehead.clear()
      }
    },

    AdicionarConta (funcionarioId) {
      if (this.formAddDe.objnomeFuncionarios !== '' && this.formAddDe.TelefoneCelular !== '' && this.formAddDe.Senha !== '' && this.formAddDe.Email !== '') {
        loading.push()
        var formData = new FormData()
        this.formAddDe.empresaId = this.CompanySelected
        formData.append('contaGeraDtoJson', JSON.stringify(this.formAddDe))
        EmployeeRepository.PostContaGera(funcionarioId, formData)
          .then(Response => {
            this.$refs.tableCollaborators.LoadAllByData(Response)
            if (Response.data) {
              this.Onload()
              toast.success('Conta criada com sucesso')
              this.$refs['add-conta'].hide()
              this.limpaCampos()
              loading.close()
            }
          })
          .catch((Error) => {
            if (Error.response.data === null && Error.response.data === undefined) {
              toast.error('Erro ao criar a conta')
              loading.close()
            } else {
              toast.warning('Username existente, escolha outro!')
              loading.close()
            }
          })
      } else {
        toast.warning('Preencha todas as informações')
      }
    },
    voltar () {
      this.$refs['add-conta'].hide()
      this.$refs['add-despesa'].show()
      this.formAddDe.Adiantamento = null
      this.zerarAutocomplete()
      this.verificarFluxo = 0
      this.formAddDe.TelefoneCelular = null
      this.formAddDe.Senha = null
      this.formAddDe.ConfSenha = null
      this.formAddDe.Username = null
      this.formAddDe.Email = null
    },

    verificaEspacos (funcionarioid) {
      let usarname = this.formAddDe.Username
      const regex = /\s+/g
      this.espacos = usarname.match(regex)

      if (this.espacos != null) {
        if (this.espacos.length !== 0) {
          toast.error('O campo Usarname não pode conter espaços, de preferência utilize o cpf ou email')
        }
      } else {
        this.AdicionarConta(funcionarioid)
      }
    },

    AdicionarFuncionario (funcionarioId) {
      if (this.formAddDe.Adiantamento === null || this.formAddDe.Adiantamento === undefined || this.formAddDe.Adiantamento === '') {
        toast.error('Selecione o valor do adiantamento')
        return
      }
      if (this.formAddDe.objnomeFuncionarios != null && this.formAddDe.objnomeFuncionarios !== '' && this.formAddDe.objnomeFuncionarios !== undefined && this.formAddDe.cargoId != null && this.formAddDe.cargoId !== undefined && funcionarioId != null) {
        loading.push()
        var formData = new FormData()
        this.formAddDe.Adiantamento = parseInt(this.formAddDe.Adiantamento)
        if (typeof this.formAddDe.objnomeFuncionarios !== 'string') {
          this.formAddDe.objnomeFuncionarios = this.formAddDe.objnomeFuncionarios.nome
        }
        this.formAddDe.saldoValor = parseFloat(this.formAddDe.saldoValor) || 0
        this.formAddDe.empresaId = this.CompanySelected
        formData.append('funcionariDtoJson', JSON.stringify(this.formAddDe))

        this.exclusao = false

        EmployeeRepository.PostAddFuncionario(funcionarioId, this.CompanySelected, formData)
          .then(Response => {
            if (Response.data) {
              this.formAddDe.funcionarioId = Response.data.funcionario.id
              if (Response.data.conta != null && Response.data.conta !== undefined) {
                this.Onload()
                this.AtualizaPrestacao = !this.AtualizaPrestacao
                this.$emit('AtualizaPrestacao', this.AtualizaPrestacao)
                toast.success('Funcionário adicionado com sucesso')
                this.cancelNewBrower()
                loading.close()
              } else {
                this.Onload()
                this.verificarFluxo = 1
                toast.warning('Funcionário sem Conta, Contate a Equipe de TI')
                this.$refs['add-despesa'].hide()
                this.$refs['warning-support'].show()
                loading.close()
              }
            }
          })
          .catch((Error) => {
            if (Error.response.data.Message != null && Error.response.data.Message !== undefined) {
              loading.close()
              this.cancelNewBrower()
              toast.warning(Error.response.data.Message)
              this.GetFuncionariosImpossibilitados({FuncionarioId: this.funcionarioId, EmpresaId: this.CompanySelected, DespesaViagem: true})
              this.$refs['add-despesa'].hide()
            } else {
              loading.close()
              this.cancelNewBrower()
              toast.warning('Erro ao criar')
            }
          })
      } else {
        toast.warning('Preencha o nome do funcionário e sua função')
      }
    },
    GetFuncionariosImpossibilitados (data) {
      loading.push()
      this.$refs['add-travel-modal-erro'].show()
      AcceptanceTermRepository.FuncionarioImpossibilitado(data)
        .then(Response => {
          this.ArrayFuncionarioImpossibilitado = Response.data
          if (this.ArrayFuncionarioImpossibilitado.despesasViagem.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesasViagem = null
          }

          if (this.ArrayFuncionarioImpossibilitado.despesasDiversos.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesasDiversos = null
          }

          if (this.ArrayFuncionarioImpossibilitado.termoAceite.length === 0) {
            this.ArrayFuncionarioImpossibilitado.termoAceite = null
          }

          if (this.ArrayFuncionarioImpossibilitado.despesa.length === 0) {
            this.ArrayFuncionarioImpossibilitado.despesa = null
          }
          loading.close()
        })
        .catch(Error => {
          toast.error(Error.response.data)
          loading.close()
        })
    },
    cancelNewBrower () {
      this.$refs['add-despesa'].hide()
      this.zerarAutocomplete()
      this.formAddDe.nomeCargo = ''
      this.verificarFluxo = 0
      this.formAddDe.cargoId = null
      this.disableDados = false
      this.formAddDe.Adiantamento = null
      if (this.$refs.favorecidoTypaehead !== undefined) {
        this.$refs.favorecidoTypaehead.clear()
      }
    },

    GetEnumValorAdiantamento () {
      TravelExpenseRepository.GetEnumValorAdiantamento()
        .then(Response => {
          this.valorAdiantamentoEnum = Response.data
          // this.formAddDe.Adiantamento = Response.data[6].obj
        })
    },
    GetLoteNovoFuncionarioByFuncionarioId (funcionarioId) {
      EmployeeRepository.GetLoteNovoFuncionarioByFuncionarioId(funcionarioId)
        .then(Response => {
          this.ObjLoteNovoFuncionario = Response.data
        })
    },
    openModal () {
      this.$refs['add-despesa'].show()
      this.selected = ''
      this.contato = ''
      this.formAddDe.Adiantamento = null
      this.formAddDe.objnomeFuncionarios = []
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    openModalEdit (value) {
      this.GetLoteNovoFuncionarioByFuncionarioId(value.funcionarioId)
      this.editinfo = value
      if (value.adiantamento !== undefined && value.adiantamento !== null) {
        this.editinfo2.Adiantamento = value.adiantamento
      } else {
        this.editinfo2.Adiantamento = null
      }
      // ZC-33: `editinfo2` vive no data() da instancia unica da grid, entao o que fica aqui vaza pro
      // proximo colaborador aberto. Sem este reset, marcar saldo no colaborador A e abrir o B mandava
      // o saldo de A no PUT de B — e o backend grava a linha APROVADA no nome errado, abatendo todo
      // excedente futuro dele. O Adiantamento acima ja era resetado; estes dois nao eram.
      this.limpaSaldoExistente()
      this.$refs['edit-despesa'].show()
    },

    // ZC-33: o par saldo so aparece depois que o backend recusa a edicao por base incompleta. Antes
    // disso o checkbox seria no-op — `Saldo`/`SaldoValor` sao lidos num unico ponto do fluxo de
    // Viagem (EditaPrimeiroAdiantamento, dentro da trava), entao marcar em quem nao precisa gravaria
    // nada e a tela ainda diria "Edicao feita com sucesso".
    limpaSaldoExistente () {
      this.editinfo2.Saldo = false
      this.editinfo2.SaldoValor = 0
      this.editinfo2.ConfirmaSemSaldoExistente = false
    },

    GetEnumValue () {
      TravelExpenseRepository.GetValorAdiantamento()
        .then((response) => {
          this.EnumInfo = response.data
          if (this.editinfo.valorLimiteDespesa === 200) {
          }
        })
    },
    cancelEditBrower () {
      this.limpaSaldoExistente()
      this.$refs['edit-despesa'].hide()
    },
    onSearchFavorecido (value) {
      this.funcionarioId = null
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo-bloc')
      el.classList.add('input-funcao-cargo')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo')
      ele.classList.add('input-funcao-cargo-bloc')
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.registrofuncionario = true
            this.$refs.favorecidoTypeaheadPoup.data = response.data.data
            this.objnomeFuncionarios = response.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCargo (value) {
      loading.push()
      TravelExpenseRepository.GetAllCargo(value)
        .then((response) => {
          if (response.data.length > 0) {
            this.$refs.favorecidooTypeaheadPoup.data = response.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFavorecido (value) {
      this.funcionarioId = null
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo-bloc')
      el.classList.add('input-funcao-cargo')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo')
      ele.classList.add('input-funcao-cargo-bloc')
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeaheadPoup.setValue(response.data.data[0])
            // this.formAddDe.objnomeFuncionarios = response.data.data
            this.GetCargobyId(response.data.data[0])
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          this.zerarAutocomplete()
          loading.close()
        })
    },
    GetCargobyId (data) {
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo')
      el.classList.add('input-funcao-cargo-bloc')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo-bloc')
      ele.classList.add('input-funcao-cargo')
      this.nomeCargo = data.cargo.nome
      this.funcionarioId = data.id
      this.formAddDe.contaId = data.contaID
      this.formAddDe.cargoId = data.cargo.id

      if (this.nomeCargo !== null || this.nomeCargo !== undefined) {
        this.disableDados = true
      } else {
        this.nomeCargo = ''
        this.disableDados = false
      }
    },
    getInput (data) {
      this.formAddDe.objnomeFuncionarios = data
    },
    getcargoId (data) {
      this.formAddDe.cargoId = data.id
    },

    Onload () {
      loading.push()
      if (this.dataSearch.FuncionarioID) {
        TravelExpenseRepository.GetAllColaboratorTableTravelExpensebyFuncionarioId(this.CompanySelected, this.dataSearch, this.$refs.tableCollaborators.pagingLimit, this.$refs.tableCollaborators.pagingIndex)
          .then((Response) => {
            this.collaboratorsArray = Response.data.data
            this.$refs.tableCollaborators.LoadAllByData(Response)
            loading.close()
          })
      } else {
        TravelExpenseRepository.GetAllPaging(this.CompanySelected, this.$refs.tableCollaborators.pagingLimit, this.$refs.tableCollaborators.pagingIndex)
          .then((Response) => {
            this.$refs.tableCollaborators.LoadAllByData(Response)
            loading.pop()
            this.collaboratorsArray = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    },
    formataData (value) {
      if (value != null) {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    addModalColaborador () {
      this.$refs['modal-add-colaborador'].show()
    },
    zerarAutocomplete () {
      this.formAddDe.objnomeFuncionarios = []
    },
    gerarLote () {
      loading.push()
      TravelExpenseRepository.GenerateLoteNovoFuncionarioViagem(this.CompanySelected)
        .then((Response) => {
          this.onDownloadExcel(Response)
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },

    onDownloadExcel (response) {
      const obj = response.data.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      // toast.success('Arquivo gerado com sucesso!')
      // loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    },
    ModalLock (value) {
      this.objColaborador = value
      this.$refs['DetailsLock'].show(value)
    },
    CloseModalLock () {
      this.PopupmotivoBloqueio = ''
      this.$refs['DetailsLock'].hide()
    },
    LockCollaborator () {
      loading.push()
      // var iconLock = document.getElementById('locked')
      var formData = new FormData()
      var bloqueioconta = this.objColaborador.contaId
      if (this.objColaborador.bloqueado === false) {
        this.lock.Bloqueado = true
      } else {
        this.lock.Bloqueado = false
      }
      this.lock.motivoBloqueio = this.PopupmotivoBloqueio
      formData.append('bloqueioZpagDto', JSON.stringify(this.lock))
      EmployeeRepository.BloqueioZpagFuncionario(bloqueioconta, formData)
        .then(Response => {
          if (this.lock.Bloqueado === true) {
            toast.success('Colaborador Bloqueado com sucesso')
            this.CloseModalLock()
          }
          if (this.lock.Bloqueado === false) {
            toast.success('Colaborador Desbloqueado com sucesso')
            this.CloseModalLock()
          }
          this.Onload()
          loading.close()
        })
        .catch((Error) => {
          toast.warning(Error)
          this.CloseModalLock()
          loading.close()
        })
    },
    OpenPopupReinforcementTravel (value) {
      this.ObjRefoco = value
      this.funcionarioId = value.funcionarioId
      this.editinfo = value
      if (value.adiantamentoDiversos !== undefined && value.adiantamentoDiversos !== null) {
        this.editinfo2.Adiantamento = value.adiantamentoDiversos
      } else {
        this.editinfo2.Adiantamento = null
      }
      this.$refs['reinforcement-despesa'].show()
    },
    cancelReinforcementBrower () {
      this.details = []
      this.$refs['reinforcement-despesa'].hide()
    },
    openModalReinforcementValue () {
      this.dataReforco = this.ObjRefoco
      this.$refs['reinforcement-despesa-value'].show()
    },
    cancelReinforcementValue () {
      this.details.valorReforco = null
      this.$refs['reinforcement-despesa-value'].hide()
    },
    openModalReinforcementEdit (value) {
      this.dataReforco = value
      this.reforcoEdit = value.valorReforco
      this.$refs['reinforcement-despesa-edit'].show()
    },
    cancelReinforcementEdit () {
      this.$refs['reinforcement-despesa-edit'].hide()
    },
    tableReinforcement () {
      if (this.dataReforco.valorReforco != null) {
        loading.push()
        var formData = new FormData()
        formData.append('reforco', JSON.stringify(this.dataReforco))
        ReinforcementRepository.PostReforco(this.dataReforco.funcionarioId, formData)
          .then(Response => {
            toast.success('Reforço incluido com sucesso')
            this.$refs['reinforcement-despesa-value'].hide()
            this.limpaCamposReforco()
            this.GetReforco()
            loading.close()
          })
          .catch((Error) => {
            toast.error('Erro ao criar o Reforço')
            loading.close()
          })
      } else {
        toast.warning('Preencha todas as informações')
      }
    },
    limpaCamposReforco () {
      this.dataReforco = []
    },
    GetReforco () {
      loading.push()
      ReinforcementRepository.GetReforcoById(this.funcionarioId, this.$refs.TabledetailsTabReforco.pagingLimit, this.$refs.TabledetailsTabReforco.pagingIndex)
        .then(Response => {
          this.$refs.TabledetailsTabReforco.LoadAllByData(Response)
          this.details = Response.data.data
          loading.pop()
        })
    },
    EditaReforco () {
      if (this.dataReforco.valorReforco != null) {
        if (this.reforcoEdit !== this.dataReforco.valorReforco) {
          if (this.reforcoEdit !== 0) {
            loading.push()
            this.dataReforco.valorReforco = this.reforcoEdit
            var formData = new FormData()
            formData.append('reforco', JSON.stringify(this.dataReforco))
            ReinforcementRepository.AlteraValorReforco(this.dataReforco.id, this.dataReforco.funcionarioID, formData)
              .then(Response => {
                this.$refs['reinforcement-despesa-value'].hide()
                this.onLoad()
                toast.success('Edição feita com sucesso')
                loading.close()
                this.limpaCamposReforco()
                this.cancelReinforcementEdit()
                if (Response.data) {
                } else {
                  this.onLoad()
                  loading.close()
                }
              })
              .catch((Error) => {
                toast.warning(Error.response.data)
                loading.close()
              })
          } else {
            toast.warning('Valor não pode ser nulo')
          }
        } else {
          toast.warning('Valor editado não pode ser igual')
        }
      } else {
        toast.warning('Escolha o valor do novo Reforço')
      }
    },
    openModalDeleteReforco (ReforcoId) {
      loading.push()
      ReinforcementRepository.ExclusaoReforco(ReforcoId.id)
        .then(Response => {
          if (Response.data) {
            loading.close()
            this.GetReforco(ReforcoId.funcionarioID)
            this.onLoad()
            toast.success('Reforço excluida com sucesso')
          }
        })
        .catch((Error) => {
          this.$refs['add-despesa'].hide()
          loading.close()
          toast.error('Erro ao excluir')
        })
    },
    openDeletePopup (value) {
      this.deletingColaborators = value
      this.$refs['delete-despesa'].show()
    },
    cancelDeletepopup () {
      this.$refs['delete-despesa'].hide()
    },
    ConfirmDelete () {
      let FuncionarioId = this.deletingColaborators.funcionarioId
      if (this.deletingColaborators.funcionarioAdiantamento === null) {
        this.funcionarioAdiantamentoId = null
      } else {
        this.funcionarioAdiantamentoId = this.deletingColaborators.funcionarioAdiantamentoId
      }
      this.exclusao = true
      loading.push()
      if (FuncionarioId != null && FuncionarioId !== undefined) {
        EmployeeRepository.Exclusao(this.funcionarioAdiantamentoId, FuncionarioId, this.CompanySelected)
          .then(Response => {
            if (Response.data) {
              loading.close()
              this.Onload()
              toast.success('Colaborador excluido com sucesso')
              this.$refs['delete-despesa'].hide()
            }
          })
          .catch((Error) => {
            loading.close()
            this.$refs['delete-despesa'].hide()
            this.GetFuncionariosImpossibilitados({FuncionarioId: FuncionarioId, EmpresaId: this.CompanySelected, DespesaViagem: true})
            toast.warning(Error.response.data == null || Error.response.data === undefined ? 'Erro ao excluir' : Error.response.data)
          })
      } else {
        loading.close()
        toast.error('Erro ao excluir')
      }
    },
    GetAcesso () {
      if (this.$store.getters['company/company'].localidade !== 'escl') {
        return this.valorAdiantamentoEnum.filter(data => data.text.includes('R$'))
      } else {
        return this.valorAdiantamentoEnum.filter(data => data.text.includes('CLP'))
      }
    },
    GetLocalidade () {
      return this.$store.getters['company/company'].localidade
    }
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/CollaboratorTableTravelExpense.js